let audioCtx = null;

export const playMessageChime = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!audioCtx) audioCtx = new Ctx();
    if (audioCtx.state === 'suspended') audioCtx.resume();
    const note = (freq, start, dur) => {
      const o = audioCtx.createOscillator();
      const g = audioCtx.createGain();
      o.type = 'sine';
      o.frequency.value = freq;
      const t = audioCtx.currentTime + start;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(0.16, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g);
      g.connect(audioCtx.destination);
      o.start(t);
      o.stop(t + dur + 0.05);
    };
    note(880, 0, 0.18);
    note(1174.66, 0.14, 0.22);
  } catch {
    // silent
  }
};

export const vibrate = () => {
  try {
    if (navigator.vibrate) navigator.vibrate([120, 60, 120]);
  } catch {
    // silent
  }
};
